import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { error, currentClient, success, loading } from '../store/state';
import { crearCliente, eliminarCliente, editarCliente } from '../store/actions/client.actions';
import { ensureClientHistorialLoaded } from '../store/actions/visit.actions';
import { Shell } from '../layout/Shell';

interface Props {
  id?: string;
}

export function ClienteFormView({ id }: Props) {
  const editing = Boolean(id);

  useEffect(() => {
    if (id) ensureClientHistorialLoaded(id);
  }, [id]);

  const cl = editing ? currentClient.value : null;

  if (editing && (!cl || cl.id !== id)) {
    return <Shell tab="clientes">{!loading.value && <p class="empty">No encontrado.</p>}</Shell>;
  }

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const payload: Record<string, unknown> = Object.fromEntries(fd);
    if (payload.visitasMensuales) payload.visitasMensuales = parseInt(String(payload.visitasMensuales));
    try {
      if (editing && cl) {
        await editarCliente(cl.id, payload);
        success.value = 'Cliente actualizado.';
        route(`/clientes/${cl.id}`);
      } else {
        await crearCliente(payload);
        success.value = 'Cliente creado. Primera visita agendada automáticamente.';
        route('/clientes');
      }
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="clientes">
      <h2>{editing ? 'Editar cliente' : 'Nuevo cliente'}</h2>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Nombre</label>
        <input name="nombre" required defaultValue={cl?.nombre} />
        <label>Dirección</label>
        <input name="direccion" defaultValue={cl?.direccion} />
        <label>Zona</label>
        <input name="zona" placeholder="Ej: Zona Norte, CABA" defaultValue={cl?.zona} />
        <label>Contacto</label>
        <input name="contactoNombre" defaultValue={cl?.contactoNombre} />
        <label>Teléfono</label>
        <input name="contactoTelefono" defaultValue={cl?.contactoTelefono} />
        <label>Email</label>
        <input name="contactoEmail" type="email" defaultValue={cl?.contactoEmail} />
        <label>Visitas por mes</label>
        <input
          name="visitasMensuales"
          type="number"
          defaultValue={cl?.visitasMensuales ?? 1}
          min={1}
          required
        />
        <label>Notas de acceso</label>
        <textarea
          name="notasAcceso"
          placeholder="Código portero, preguntar por..., estacionar en..."
          defaultValue={cl?.notasAcceso}
        />
        <button class="primary" type="submit">
          {editing ? 'Guardar cambios' : 'Guardar'}
        </button>
        <button
          class="secondary"
          type="button"
          onClick={() => route(editing && cl ? `/clientes/${cl.id}` : '/clientes')}
        >
          Cancelar
        </button>
      </form>
      {editing && cl && (
        <button
          class="danger-outline"
          style={{ marginTop: 12 }}
          onClick={() => eliminarCliente(cl.id)}
        >
          Desactivar cliente
        </button>
      )}
    </Shell>
  );
}
